import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { And, RandomNumberLessThan, RuleInterface } from '@vendasta/automata';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'automata-ab-branch-panel',
  templateUrl: './a-b-branch-panel.component.html',
  styleUrls: ['./a-b-branch-panel.component.scss'],
  imports: [CommonModule, TranslateModule, MatSliderModule, GalaxyFormFieldModule, MatInputModule, FormsModule],
})
export class ABBranchPanelComponent extends CommonActionPanelComponent implements OnInit, OnDestroy {
  valueForA = 50;
  valueForB = 100 - this.valueForA;

  private destroyed$$ = new Subject<void>();

  ngOnInit(): void {
    super.ngOnInit();
    if (this.step?.choices?.rules?.length > 0) {
      const and = And.fromRuleInterface(this.step?.choices?.rules[0]);
      const aBranchValue = and.listValuesByVariablePath('aBranchCondition');
      if (!!aBranchValue && aBranchValue.length > 0) {
        this.valueForA = +aBranchValue[0];
        this.valAChange(this.valueForA);
      }
    }

    this.savingEnabled = true;
  }

  ngOnDestroy(): void {
    this.destroyed$$.next();
    this.destroyed$$.complete();
  }

  valAChange(value: number): void {
    if (value > 100) {
      value = 100;
    }
    if (value < 0) {
      value = 0;
    }
    this.valueForA = value;
    this.valueForB = 100 - value;
  }

  valBChange(value: number): void {
    if (value > 100) {
      value = 100;
    }
    if (value < 0) {
      value = 0;
    }
    this.valueForB = value;
    this.valueForA = 100 - value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  getData(): any {
    return {};
  }

  getRules(): RuleInterface[] {
    const rules: any = [new RandomNumberLessThan('aBranchCondition', +this.valueForA, '')];
    let next = '';
    if (this.step?.taskDefinitionId) {
      next = this.step?.choices?.rules[0]?.next;
    }
    return [new And(rules, next).toRuleInterface()];
  }

  isFormValid(): boolean {
    return (
      Number.isInteger(this.valueForA) &&
      this.valueForA >= 0 &&
      this.valueForA <= 100 &&
      Number.isInteger(this.valueForB) &&
      this.valueForB >= 0 &&
      this.valueForB <= 100
    );
  }
}
